import script from "./ActiveActionsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActiveActionsTable.vue?vue&type=script&setup=true&lang=ts"

import "./ActiveActionsTable.vue?vue&type=style&index=0&id=2b5f3cee&lang=scss"
import "./ActiveActionsTable.vue?vue&type=style&index=1&id=2b5f3cee&lang=scss"

const __exports__ = script;

export default __exports__